import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { IconButton } from '@material-ui/core';
import { Link } from "react-router-dom";
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import SearchIcon from '@material-ui/icons/Search';

import {
    toggleFaltaDiario,
    lancaFaltasDiario,
    buscaDiario
} from 'actions/Diario';

import './grade.css';

class GradeDiario extends Component {

    constructor(props) {
        super(props);

        this.state = {
            searchTerm: '',
            selectedComponenteEscolaId: null
        };
    }

    componentDidMount() {
        this.initializeSelection();
    }

    componentDidUpdate(prevProps) {

        const { diario } = this.props;

        if (diario && prevProps.diario !== diario) {
            this.initializeSelection();
        }
    }

    initializeSelection = () => {

        const { diario } = this.props;

        if (!diario) return;

        const discList = diario.disciplinas || [];

        if (discList.length > 0) {

            const first = discList[0];

            this.setState({
                selectedComponenteEscolaId: first.componenteEscolaId || first.id
            });
        }
    }

    handleSwitchTurma = (turmaId) => {

        const { anoLetivo, data } = this.props;

        this.props.buscaDiario({
            turmaId,
            anoLetivo,
            data: moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
        });
    }

    handleToggleFalta = (matriculaId, componenteEscolaId, faltou) => {

        this.props.toggleFaltaDiario({
            matriculaId,
            componenteEscolaId,
            faltou
        });
    }

    renderAvatar = (aluno) => {

        if (aluno.foto) {

            const src = aluno.foto.startsWith('data:')
                ? aluno.foto
                : `data:image/jpeg;base64,${aluno.foto}`;

            return <img src={src} className="student-avatar" alt="" />;
        }

        const letra = aluno.nomeAluno?.charAt(0) || "A";

        return (
            <div className="student-avatar-initials">
                {letra}
            </div>
        );
    }

    render() {

        const { diario, loader } = this.props;

        if (!diario) return null;

        const { disciplinas, alunos, turmas } = diario;

        const { searchTerm, selectedComponenteEscolaId } = this.state;

        const filteredAlunos = (alunos || []).filter(a =>
            a.nomeAluno?.toLowerCase().includes(searchTerm.toLowerCase())
        );

        const presentes = filteredAlunos.filter(aluno => {

            const falta = (aluno.faltas || []).find(
                f => f.componenteEscolaId === selectedComponenteEscolaId
            );

            return !(falta && falta.faltou);

        }).length;

        const ausentes = filteredAlunos.length - presentes;

        return (

            <div className="diario-container">

                {/* NAV */}

                <div className="diario-nav-bar">

                    <Link to="/app/inicio">
                        <AiFillHome size={20} />
                    </Link>

                    <div className="diario-search-container">

                        <input
                            className="diario-search-input"
                            placeholder="Pesquisar"
                            value={searchTerm}
                            onChange={(e) =>
                                this.setState({ searchTerm: e.target.value })
                            }
                        />

                        <SearchIcon className="diario-search-icon" />

                    </div>
                    <div>
                        <div className="diario-stat-box presente">
                            { this.props.data }
                        </div>
                    </div>
                    <div className="diario-turma-group">

                        {(turmas || []).map(t => (

                            <div
                                key={t.id}
                                className={`diario-turma-segment ${t.id === this.props.turmaId ? 'active' : ''}`}
                                onClick={() => this.handleSwitchTurma(t.id)}
                            >
                                {t.title}
                            </div>

                        ))}

                    </div>

                    <div className="diario-stats-container">

                        <div className="diario-stat-box presente">
                            Total: {presentes} Alunos presentes
                        </div>

                        <div className="diario-stat-box ausente">
                            Total: {ausentes} Alunos ausentes
                        </div>

                    </div>

                </div>


                {/* DISCIPLINAS */}

                <div className="diario-subject-tabs">

                    {(disciplinas || []).map(d => {

                        const id = d.componenteEscolaId || d.id;

                        return (

                            <div
                                key={id}
                                className={`diario-subject-tab ${selectedComponenteEscolaId === id ? 'active' : ''}`}
                                onClick={() =>
                                    this.setState({
                                        selectedComponenteEscolaId: id
                                    })
                                }
                            >
                                {d.nome}
                            </div>

                        );
                    })}

                </div>


                {/* GRID OU LOADER */}

                {loader ? (

                    <div className="diario-loader">

                        <div className="loader"></div>

                        <p>Carregando alunos...</p>

                    </div>

                ) : (

                    <div className="diario-student-grid">

                        {filteredAlunos.map(aluno => {

                            const falta = (aluno.faltas || []).find(
                                f => f.componenteEscolaId === selectedComponenteEscolaId
                            );

                            const ausente = falta && falta.faltou;

                            return (

                                <div
                                    key={aluno.matriculaId}
                                    className={`student-card ${ausente ? 'ausente' : 'presente'}`}
                                >

                                    <div className="student-card-main">

                                        {this.renderAvatar(aluno)}

                                        <div className="student-info">

                                            <div className="student-name">
                                                {aluno.nomeAluno}
                                            </div>

                                            <div className="attendance-toggle">

                                                <button
                                                    className={`toggle-btn ausente ${ausente ? 'active' : ''}`}
                                                    onClick={() =>
                                                        this.handleToggleFalta(
                                                            aluno.matriculaId,
                                                            selectedComponenteEscolaId,
                                                            true
                                                        )
                                                    }
                                                >
                                                    Ausente
                                                </button>

                                                <button
                                                    className={`toggle-btn presente ${!ausente ? 'active' : ''}`}
                                                    onClick={() =>
                                                        this.handleToggleFalta(
                                                            aluno.matriculaId,
                                                            selectedComponenteEscolaId,
                                                            false
                                                        )
                                                    }
                                                >
                                                    Presente
                                                </button>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            );
                        })}

                    </div>

                )}


                {/* FOOTER */}

                <div className="diario-footer">

                    <button className="btn-cancelar">
                        Cancelar
                    </button>

                    <button className="btn-finalizar">
                        Finalizar
                    </button>

                </div>

            </div>
        );
    }
}

const mapStateToProps = ({ diario }) => ({
    ...diario
});

export default connect(
    mapStateToProps,
    {
        toggleFaltaDiario,
        lancaFaltasDiario,
        buscaDiario
    }
)(GradeDiario);